import React, { PureComponent } from 'react'
import { Breadcrumb, Icon } from 'antd'
import { Link, withRouter } from 'react-router-dom'

import { findSupLink } from '../../init/tool'
import { menus } from '_src/config/index'

import './index.less'

@withRouter
class BreadcrumbDom extends PureComponent {
  getBreadcrumb () {
    const { location: {pathname} } = this.props
    let titleArr = findSupLink(menus, pathname, 'title') 
    let icon = findSupLink(menus, pathname, 'icon')
    if (pathname==='/home' || pathname === '/') {
      return <Breadcrumb><Breadcrumb.Item><Icon type='home' />首页</Breadcrumb.Item></Breadcrumb>
    }
    if (titleArr.length) {
      const list = titleArr.map((item, index)=>{
        return {title: item, icon: icon[index]}
      })
      const Node = list.map((item)=>{
        return (
          <Breadcrumb.Item key = {pathname}><Icon type = {item.icon} />
            {item.title}
          </Breadcrumb.Item>

        ) 
      })
      return (
        <Breadcrumb>
          <Breadcrumb.Item><Link to="/home"><Icon type='home' />首页</Link></Breadcrumb.Item>
          {
            Node
          }
        </Breadcrumb>
      )
    }
  } 
  render () {
    return (
      <div>{this.getBreadcrumb()}</div>
    )
  }
}

export default BreadcrumbDom